import { useEffect, useState } from "react";

import {
    useNavigate,
    useSearchParams,
} from "react-router-dom";

import {
    doc,
    getDoc,
    setDoc,
} from "firebase/firestore";

import { db } from "../firebase/firebase";

export default function ServiceView() {

    const navigate = useNavigate();

    const [searchParams] =
        useSearchParams();

    const id =
        searchParams.get("id");

    const [loading, setLoading] =
        useState(true);

    const [saving, setSaving] =
        useState(false);

    const [service, setService] =
        useState({

            id: "",

            title: "",

            slug: "",

            category: "",

            status: "active",

            startingPrice: "",

            deliveryTime: "",

            shortDescription: "",

            hero: {
                title: "",
                subtitle: "",
                badge: "",
            },

            media: {
                thumbnail: "",
                banner: "",
                logo: "",
                gallery: [],
            },

            serviceType: [],

            tags: [],

            highlights: [],

            features: [],

            technologies: [],

            industries: [],

            whyChooseUs: [],

            relatedServices: [],

            process: [],

            packages: [],

            portfolio: [],

            testimonials: [],

            faqs: [],

            seo: {
                seoTitle: "",
                seoDescription:
                    "",
                seoKeywords: [],
            },

            support: {
                maintenance: true,
                supportDuration:
                    "",
                trainingIncluded:
                    true,
            },

            stats: {
                projectsCompleted:
                    "",
                happyClients: "",
                experience: "",
            },

            theme: {
                primary:
                    "#f97316",
                secondary:
                    "#3b82f6",
            },

            cta: {
                title: "",
                description: "",

                primaryButton: {
                    text: "",
                    link: "",
                },

                secondaryButton:
                {
                    text: "",
                    link: "",
                },
            },
        });

    /* ---------------- FETCH ---------------- */

    useEffect(() => {

        fetchService();

    }, []);

    const fetchService =
        async () => {

            try {

                const snap =
                    await getDoc(
                        doc(
                            db,
                            "services",
                            "allServices"
                        )
                    );

                if (
                    snap.exists()
                ) {

                    const allServices =
                        snap.data()
                            .services ||
                        [];

                    const found =
                        allServices.find(
                            (
                                s
                            ) =>
                                s.id ===
                                id
                        );

                    if (
                        found
                    ) {

                        setService(
                            found
                        );

                    } else {

                        alert(
                            "Service not found"
                        );
                    }
                }

            } catch (err) {

                console.error(
                    err
                );

            } finally {

                setLoading(
                    false
                );
            }
        };

    /* ---------------- SAVE ---------------- */

    const handleSave =
        async () => {

            try {

                setSaving(
                    true
                );

                const ref =
                    doc(
                        db,
                        "services",
                        "allServices"
                    );

                const snap =
                    await getDoc(
                        ref
                    );

                if (
                    !snap.exists()
                ) {

                    return alert(
                        "Document missing"
                    );
                }

                const allServices =
                    snap.data()
                        .services ||
                    [];

                const updated =
                    allServices.map(
                        (
                            s
                        ) => {

                            if (
                                s.id ===
                                id
                            ) {

                                return {

                                    ...service,

                                    updatedAt:
                                        new Date().toISOString(),
                                };
                            }

                            return s;
                        }
                    );

                await setDoc(
                    ref,
                    {
                        services:
                            updated,
                    }
                );

                alert(
                    "Updated ✅"
                );

            } catch (err) {

                console.error(
                    err
                );

                alert(
                    "Failed ❌"
                );

            } finally {

                setSaving(
                    false
                );
            }
        };

    /* ---------------- ARRAY HELPERS ---------------- */

    const addArrayItem =
        (
            field
        ) => {

            setService({
                ...service,

                [field]: [
                    ...(service[
                        field
                    ] || []),
                    "",
                ],
            });
        };

    const updateArray =
        (
            field,
            index,
            value
        ) => {

            const updated =
                [
                    ...(service[
                        field
                    ] || []),
                ];

            updated[index] =
                value;

            setService({
                ...service,
                [field]:
                    updated,
            });
        };

    const removeArrayItem =
        (
            field,
            index
        ) => {

            const updated =
                service[
                    field
                ].filter(
                    (
                        _,
                        i
                    ) =>
                        i !==
                        index
                );

            setService({
                ...service,
                [field]:
                    updated,
            });
        };

    /* ---------------- GALLERY ---------------- */

    const addGalleryImage =
        () => {

            setService({
                ...service,

                media: {
                    ...service.media,

                    gallery: [
                        ...(service
                            .media
                            ?.gallery ||
                            []),
                        "",
                    ],
                },
            });
        };



    /* ---------------- DELETE HELPERS ---------------- */

    const removeProcess = (index) => {

        const updated =
            service.process.filter(
                (_, i) => i !== index
            );

        setService({
            ...service,
            process: updated,
        });
    };

    const removePortfolio = (index) => {

        const updated =
            service.portfolio.filter(
                (_, i) => i !== index
            );

        setService({
            ...service,
            portfolio: updated,
        });
    };

    const removeTestimonial = (index) => {

        const updated =
            service.testimonials.filter(
                (_, i) => i !== index
            );

        setService({
            ...service,
            testimonials: updated,
        });
    };

    const removeFaq = (index) => {

        const updated =
            service.faqs.filter(
                (_, i) => i !== index
            );

        setService({
            ...service,
            faqs: updated,
        });
    };

    /* ---------------- PROCESS ---------------- */

    const addProcess =
        () => {

            setService({
                ...service,

                process: [
                    ...(service.process ||
                        []),

                    {
                        title: "",
                        description:
                            "",
                    },
                ],
            });
        };

    /* ---------------- PACKAGES ---------------- */

    const addPackage =
        () => {

            setService({
                ...service,

                packages: [
                    ...(service.packages ||
                        []),

                    {
                        name: "",
                        price: "",
                        recommended:
                            false,
                        features:
                            [],
                    },
                ],
            });
        };

    /* ---------------- PORTFOLIO ---------------- */

    const addPortfolio =
        () => {

            setService({
                ...service,

                portfolio: [
                    ...(service.portfolio ||
                        []),

                    {
                        title: "",
                        image: "",
                    },
                ],
            });
        };

    /* ---------------- TESTIMONIAL ---------------- */

    const addTestimonial =
        () => {

            setService({
                ...service,

                testimonials:
                    [
                        ...(service.testimonials ||
                            []),

                        {
                            name: "",
                            company:
                                "",
                            review:
                                "",
                        },
                    ],
            });
        };

    /* ---------------- FAQ ---------------- */

    const addFaq =
        () => {

            setService({
                ...service,

                faqs: [
                    ...(service.faqs ||
                        []),

                    {
                        question:
                            "",
                        answer:
                            "",
                    },
                ],
            });
        };

    if (loading) {

        return (
            <div className="text-white">
                Loading...
            </div>
        );
    }

    return (

        <div className="text-white pb-40">

            {/* HEADER */}

            <div className="flex justify-between items-center mb-8">

                <div>

                    <h1 className="text-3xl font-bold text-orange-500">

                        {
                            service.title
                        }

                    </h1>

                    <p className="text-slate-400 mt-1">

                        Manage Service

                    </p>

                </div>

                <button
                    onClick={() =>
                        navigate(-1)
                    }
                    className="bg-white/10 hover:bg-white/20 px-4 py-2 rounded-xl"
                >
                    Back
                </button>

            </div>

            {/* OVERVIEW */}

            <SectionCard title="Overview">

                <div className="grid md:grid-cols-2 gap-5">

                    <Input
                        label="Title"
                        value={
                            service.title
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                title:
                                    e.target
                                        .value,
                            })
                        }
                    />

                    <Input
                        label="Slug"
                        value={
                            service.slug
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                slug: e
                                    .target
                                    .value,
                            })
                        }
                    />

                    <Input
                        label="Category"
                        value={
                            service.category
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                category:
                                    e.target
                                        .value,
                            })
                        }
                    />

                    <Input
                        label="Status"
                        value={
                            service.status
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                status:
                                    e.target
                                        .value,
                            })
                        }
                    />

                    <Input
                        label="Starting Price"
                        value={
                            service.startingPrice
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                startingPrice:
                                    e.target
                                        .value,
                            })
                        }
                    />

                    <Input
                        label="Delivery Time"
                        value={
                            service.deliveryTime
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                deliveryTime:
                                    e.target
                                        .value,
                            })
                        }
                    />

                </div>

                <div className="mt-5">

                    <Textarea
                        label="Short Description"
                        value={
                            service.shortDescription
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                shortDescription:
                                    e.target
                                        .value,
                            })
                        }
                    />

                </div>

            </SectionCard>

            {/* HERO */}

            <SectionCard title="Hero">

                <div className="grid md:grid-cols-3 gap-5">

                    <Input
                        label="Hero Title"
                        value={
                            service.hero
                                ?.title
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                hero: {
                                    ...service.hero,

                                    title:
                                        e
                                            .target
                                            .value,
                                },
                            })
                        }
                    />

                    <Input
                        label="Subtitle"
                        value={
                            service.hero
                                ?.subtitle
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                hero: {
                                    ...service.hero,

                                    subtitle:
                                        e
                                            .target
                                            .value,
                                },
                            })
                        }
                    />

                    <Input
                        label="Badge"
                        value={
                            service.hero
                                ?.badge
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                hero: {
                                    ...service.hero,

                                    badge:
                                        e
                                            .target
                                            .value,
                                },
                            })
                        }
                    />

                </div>

            </SectionCard>

            {/* MEDIA */}

            <SectionCard title="Media">

                <div className="grid md:grid-cols-3 gap-5">

                    {[
                        "thumbnail",
                        "banner",
                        "logo",
                    ].map(
                        (
                            field
                        ) => (

                            <div
                                key={
                                    field
                                }
                            >

                                <Input
                                    label={
                                        field
                                    }
                                    value={
                                        service
                                            .media?.[
                                        field
                                        ]
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        setService(
                                            {
                                                ...service,

                                                media:
                                                {
                                                    ...service.media,

                                                    [field]:
                                                        e
                                                            .target
                                                            .value,
                                                },
                                            }
                                        )
                                    }
                                />

                                {service
                                    .media?.[
                                    field
                                ] && (

                                        <img
                                            src={
                                                service
                                                    .media?.[
                                                field
                                                ]
                                            }
                                            alt=""
                                            className="mt-3 rounded-xl h-40 w-full object-contain border border-white/10"
                                        />

                                    )}

                            </div>

                        )
                    )}

                </div>

                {/* GALLERY */}

                <div className="mt-8">

                    <div className="flex justify-between items-center mb-4">

                        <h3 className="text-lg font-semibold">
                            Gallery
                        </h3>

                        <button
                            onClick={
                                addGalleryImage
                            }
                            className="bg-orange-500 px-4 py-2 rounded-xl"
                        >
                            + Add
                        </button>

                    </div>

                    <div className="grid md:grid-cols-3 gap-5">

                        {(service
                            .media
                            ?.gallery ||
                            []
                        ).map(
                            (
                                img,
                                index
                            ) => (

                                <div
                                    key={
                                        index
                                    }
                                >

                                    <input
                                        value={
                                            img
                                        }
                                        onChange={(
                                            e
                                        ) => {

                                            const updated =
                                                [
                                                    ...service
                                                        .media
                                                        .gallery,
                                                ];

                                            updated[
                                                index
                                            ] =
                                                e
                                                    .target
                                                    .value;

                                            setService(
                                                {
                                                    ...service,

                                                    media:
                                                    {
                                                        ...service.media,

                                                        gallery:
                                                            updated,
                                                    },
                                                }
                                            );

                                        }}
                                        className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
                                    />

                                    {img && (

                                        <img
                                            src={
                                                img
                                            }
                                            alt=""
                                            className="mt-3 rounded-xl h-40 w-full object-contain"
                                        />

                                    )}

                                </div>

                            )
                        )}

                    </div>

                </div>

            </SectionCard>

            {/* ARRAYS */}

            {[
                "serviceType",
                "tags",
                "highlights",
                "features",
                "technologies",
                "industries",
                "whyChooseUs",
                "relatedServices",
            ].map(
                (
                    field
                ) => (

                    <ArraySection
                        key={
                            field
                        }
                        title={
                            field
                        }
                        field={
                            field
                        }
                        item={
                            service
                        }
                        addArrayItem={
                            addArrayItem
                        }
                        updateArray={
                            updateArray
                        }
                        removeArrayItem={
                            removeArrayItem
                        }
                    />

                )
            )}

            {/* PROCESS */}

            <SectionCard
                title="Process"
                buttonText="+ Add Step"
                onAdd={
                    addProcess
                }
            >

                {(service.process ||
                    []
                ).map(
                    (
                        step,
                        index
                    ) => (

                        <div
                            key={
                                index
                            }
                            className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                        >

                            <div className="grid md:grid-cols-2 gap-5">

                                <Input
                                    label="Title"
                                    value={
                                        step.title
                                    }
                                    onChange={(
                                        e
                                    ) => {

                                        const updated =
                                            [
                                                ...service.process,
                                            ];

                                        updated[
                                            index
                                        ].title =
                                            e
                                                .target
                                                .value;

                                        setService(
                                            {
                                                ...service,

                                                process:
                                                    updated,
                                            }
                                        );

                                    }}
                                />

                                <Textarea
                                    label="Description"
                                    value={
                                        step.description
                                    }
                                    onChange={(
                                        e
                                    ) => {

                                        const updated =
                                            [
                                                ...service.process,
                                            ];

                                        updated[
                                            index
                                        ].description =
                                            e
                                                .target
                                                .value;

                                        setService(
                                            {
                                                ...service,

                                                process:
                                                    updated,
                                            }
                                        );

                                    }}
                                />

                            </div>


                            <button
                                onClick={() =>
                                    removeProcess(index)
                                }
                                className="mt-4 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-xl"
                            >
                                Delete Step
                            </button>
                        </div>

                    )
                )}

            </SectionCard>

            {/* PACKAGES */}

            {/* <SectionCard
                title="Packages"
                buttonText="+ Add Package"
                onAdd={
                    addPackage
                }
            >

                {(service.packages ||
                    []
                ).map(
                    (
                        pack,
                        index
                    ) => (

                        <div
                            key={
                                index
                            }
                            className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                        >

                            <div className="grid md:grid-cols-3 gap-5">

                                <Input
                                    label="Name"
                                    value={
                                        pack.name
                                    }
                                />

                                <Input
                                    label="Price"
                                    value={
                                        pack.price
                                    }
                                />

                                <div>

                                    <label className="block mb-2 text-sm text-slate-300">
                                        Recommended
                                    </label>

                                    <input
                                        type="checkbox"
                                        checked={
                                            pack.recommended
                                        }
                                    />

                                </div>

                            </div>

                        </div>

                    )
                )}

            </SectionCard> */}
            {/* PACKAGES */}

            <SectionCard
                title="Packages"
                buttonText="+ Add Package"
                onAdd={addPackage}
            >

                {(service.packages || []).map(
                    (pack, index) => (

                        <div
                            key={index}
                            className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                        >

                            <div className="grid md:grid-cols-3 gap-5">

                                <Input
                                    label="Name"
                                    value={pack.name}
                                    onChange={(e) => {

                                        const updated = [
                                            ...service.packages,
                                        ];

                                        updated[index].name =
                                            e.target.value;

                                        setService({
                                            ...service,
                                            packages: updated,
                                        });
                                    }}
                                />

                                <Input
                                    label="Price"
                                    value={pack.price}
                                    onChange={(e) => {

                                        const updated = [
                                            ...service.packages,
                                        ];

                                        updated[index].price =
                                            e.target.value;

                                        setService({
                                            ...service,
                                            packages: updated,
                                        });
                                    }}
                                />

                                <div>

                                    <label className="block mb-2 text-sm text-slate-300">
                                        Recommended
                                    </label>

                                    <input
                                        type="checkbox"
                                        checked={pack.recommended}
                                        onChange={(e) => {

                                            const updated = [
                                                ...service.packages,
                                            ];

                                            updated[index].recommended =
                                                e.target.checked;

                                            setService({
                                                ...service,
                                                packages: updated,
                                            });
                                        }}
                                    />

                                </div>

                            </div>

                        </div>

                    )
                )}

            </SectionCard>


            {/* PORTFOLIO */}

            {/* <SectionCard
                title="Portfolio"
                buttonText="+ Add Portfolio"
                onAdd={
                    addPortfolio
                }
            >

                <div className="flex flex-wrap justify-between">
                    {(service.portfolio ||
                        []
                    ).map(
                        (
                            item,
                            index
                        ) => (

                            <div
                                key={
                                    index
                                }
                                className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5 w-[30%]"
                            >

                                <Input
                                    label="Title"
                                    value={
                                        item.title
                                    }
                                />

                                <div className="mt-5">

                                    <Input
                                        label="Image"
                                        value={
                                            item.image
                                        }
                                    />

                                    {item.image && (

                                        <img
                                            src={
                                                item.image
                                            }
                                            alt=""
                                            className="mt-4 rounded-xl h-48 w-full object-contain"
                                        />

                                    )}

                                </div>

                                <button
                                    onClick={() =>
                                        removePortfolio(index)
                                    }
                                    className="mt-4 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-xl"
                                >
                                    Delete Portfolio
                                </button>

                            </div>

                        )
                    )}

                </div>

            </SectionCard> */}
            {/* PORTFOLIO */}

            <SectionCard
                title="Portfolio"
                buttonText="+ Add Portfolio"
                onAdd={addPortfolio}
            >

                <div className="flex flex-wrap justify-between">

                    {(service.portfolio || []).map(
                        (item, index) => (

                            <div
                                key={index}
                                className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5 w-[30%]"
                            >

                                <Input
                                    label="Title"
                                    value={item.title}
                                    onChange={(e) => {

                                        const updated = [
                                            ...service.portfolio,
                                        ];

                                        updated[index].title =
                                            e.target.value;

                                        setService({
                                            ...service,
                                            portfolio: updated,
                                        });
                                    }}
                                />

                                <div className="mt-5">

                                    <Input
                                        label="Image"
                                        value={item.image}
                                        onChange={(e) => {

                                            const updated = [
                                                ...service.portfolio,
                                            ];

                                            updated[index].image =
                                                e.target.value;

                                            setService({
                                                ...service,
                                                portfolio: updated,
                                            });
                                        }}
                                    />

                                    {item.image && (

                                        <img
                                            src={item.image}
                                            alt=""
                                            className="mt-4 rounded-xl h-48 w-full object-contain"
                                        />

                                    )}

                                </div>

                                <button
                                    onClick={() =>
                                        removePortfolio(index)
                                    }
                                    className="mt-4 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-xl"
                                >
                                    Delete Portfolio
                                </button>

                            </div>

                        )
                    )}

                </div>

            </SectionCard>


            {/* TESTIMONIALS */}

            {/* <SectionCard
                title="Testimonials"
                buttonText="+ Add Testimonial"
                onAdd={
                    addTestimonial
                }
            >

                {(service.testimonials ||
                    []
                ).map(
                    (
                        t,
                        index
                    ) => (

                        <div
                            key={
                                index
                            }
                            className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                        >

                            <div className="grid md:grid-cols-2 gap-5">

                                <Input
                                    label="Name"
                                    value={
                                        t.name
                                    }
                                />

                                <Input
                                    label="Company"
                                    value={
                                        t.company
                                    }
                                />

                            </div>

                            <div className="mt-5">

                                <Textarea
                                    label="Review"
                                    value={
                                        t.review
                                    }
                                />

                            </div>

                            <button
                                onClick={() =>
                                    removeTestimonial(index)
                                }
                                className="mt-4 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-xl"
                            >
                                Delete Testimonial
                            </button>

                        </div>

                    )
                )}

            </SectionCard> */}
            {/* TESTIMONIALS */}

            <SectionCard
                title="Testimonials"
                buttonText="+ Add Testimonial"
                onAdd={addTestimonial}
            >

                {(service.testimonials || []).map(
                    (t, index) => (

                        <div
                            key={index}
                            className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                        >

                            <div className="grid md:grid-cols-2 gap-5">

                                <Input
                                    label="Name"
                                    value={t.name}
                                    onChange={(e) => {

                                        const updated = [
                                            ...service.testimonials,
                                        ];

                                        updated[index].name =
                                            e.target.value;

                                        setService({
                                            ...service,
                                            testimonials: updated,
                                        });
                                    }}
                                />

                                <Input
                                    label="Company"
                                    value={t.company}
                                    onChange={(e) => {

                                        const updated = [
                                            ...service.testimonials,
                                        ];

                                        updated[index].company =
                                            e.target.value;

                                        setService({
                                            ...service,
                                            testimonials: updated,
                                        });
                                    }}
                                />

                            </div>

                            <div className="mt-5">

                                <Textarea
                                    label="Review"
                                    value={t.review}
                                    onChange={(e) => {

                                        const updated = [
                                            ...service.testimonials,
                                        ];

                                        updated[index].review =
                                            e.target.value;

                                        setService({
                                            ...service,
                                            testimonials: updated,
                                        });
                                    }}
                                />

                            </div>

                            <button
                                onClick={() =>
                                    removeTestimonial(index)
                                }
                                className="mt-4 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-xl"
                            >
                                Delete Testimonial
                            </button>

                        </div>

                    )
                )}

            </SectionCard>


            {/* FAQ */}

            {/* <SectionCard
                title="FAQs"
                buttonText="+ Add FAQ"
                onAdd={
                    addFaq
                }
            >

                {(service.faqs ||
                    []
                ).map(
                    (
                        faq,
                        index
                    ) => (

                        <div
                            key={
                                index
                            }
                            className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                        >

                            <Input
                                label="Question"
                                value={
                                    faq.question
                                }
                            />

                            <div className="mt-5">

                                <Textarea
                                    label="Answer"
                                    value={
                                        faq.answer
                                    }
                                />

                            </div>

                            <button
                                onClick={() =>
                                    removeFaq(index)
                                }
                                className="mt-4 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-xl"
                            >
                                Delete FAQ
                            </button>
                        </div>

                    )
                )}

            </SectionCard> */}
            {/* FAQ */}

            <SectionCard
                title="FAQs"
                buttonText="+ Add FAQ"
                onAdd={addFaq}
            >

                {(service.faqs || []).map(
                    (faq, index) => (

                        <div
                            key={index}
                            className="bg-black/30 border border-white/10 rounded-2xl p-5 mb-5"
                        >

                            <Input
                                label="Question"
                                value={faq.question}
                                onChange={(e) => {

                                    const updated = [
                                        ...service.faqs,
                                    ];

                                    updated[index].question =
                                        e.target.value;

                                    setService({
                                        ...service,
                                        faqs: updated,
                                    });
                                }}
                            />

                            <div className="mt-5">

                                <Textarea
                                    label="Answer"
                                    value={faq.answer}
                                    onChange={(e) => {

                                        const updated = [
                                            ...service.faqs,
                                        ];

                                        updated[index].answer =
                                            e.target.value;

                                        setService({
                                            ...service,
                                            faqs: updated,
                                        });
                                    }}
                                />

                            </div>

                            <button
                                onClick={() =>
                                    removeFaq(index)
                                }
                                className="mt-4 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-xl"
                            >
                                Delete FAQ
                            </button>

                        </div>

                    )
                )}

            </SectionCard>


            {/* SEO */}

            <SectionCard title="SEO">

                <div className="space-y-5">

                    <Input
                        label="SEO Title"
                        value={
                            service.seo
                                ?.seoTitle
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                seo: {
                                    ...service.seo,

                                    seoTitle:
                                        e
                                            .target
                                            .value,
                                },
                            })
                        }
                    />

                    <Textarea
                        label="SEO Description"
                        value={
                            service.seo
                                ?.seoDescription
                        }
                        onChange={(e) =>
                            setService({
                                ...service,

                                seo: {
                                    ...service.seo,

                                    seoDescription:
                                        e
                                            .target
                                            .value,
                                },
                            })
                        }
                    />

                </div>

            </SectionCard>

            {/* THEME */}

            <SectionCard title="Theme">

                <div className="grid md:grid-cols-2 gap-5">

                    <div>

                        <label className="block mb-2 text-sm text-slate-300">
                            Primary Color
                        </label>

                        <input
                            type="color"
                            value={
                                service.theme
                                    ?.primary
                            }
                            onChange={(e) =>
                                setService({
                                    ...service,

                                    theme: {
                                        ...service.theme,

                                        primary:
                                            e
                                                .target
                                                .value,
                                    },
                                })
                            }
                        />

                    </div>

                    <div>

                        <label className="block mb-2 text-sm text-slate-300">
                            Secondary Color
                        </label>

                        <input
                            type="color"
                            value={
                                service.theme
                                    ?.secondary
                            }
                            onChange={(e) =>
                                setService({
                                    ...service,

                                    theme: {
                                        ...service.theme,

                                        secondary:
                                            e
                                                .target
                                                .value,
                                    },
                                })
                            }
                        />

                    </div>

                </div>

            </SectionCard>

            {/* SAVE */}

            <div className="fixed bottom-5 right-5 z-50">

                <button
                    onClick={
                        handleSave
                    }
                    disabled={saving}
                    className="bg-orange-500 hover:bg-orange-600 px-8 py-4 rounded-2xl shadow-2xl font-semibold"
                >
                    {saving
                        ? "Saving..."
                        : "Save"}
                </button>

            </div>

        </div>
    );
}

/* ---------------- COMPONENTS ---------------- */

function Input({
    label,
    ...props
}) {

    return (

        <div>

            <label className="block mb-2 text-sm text-slate-300">
                {label}
            </label>

            <input
                {...props}
                className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
            />

        </div>
    );
}

function Textarea({
    label,
    ...props
}) {

    return (

        <div>

            <label className="block mb-2 text-sm text-slate-300">
                {label}
            </label>

            <textarea
                {...props}
                rows={5}
                className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
            />

        </div>
    );
}

function SectionCard({
    title,
    buttonText,
    onAdd,
    children,
}) {

    return (

        <div className="bg-white/5 border border-white/10 rounded-3xl p-6 mb-8">

            <div className="flex items-center justify-between mb-5">

                <h2 className="text-xl font-semibold">
                    {title}
                </h2>

                {buttonText && (

                    <button
                        onClick={
                            onAdd
                        }
                        className="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-xl"
                    >
                        {
                            buttonText
                        }
                    </button>

                )}

            </div>

            {children}

        </div>
    );
}

function ArraySection({
    title,
    field,
    item,
    addArrayItem,
    updateArray,
    removeArrayItem,
}) {

    return (

        <SectionCard
            title={title}
            buttonText={`+ Add ${title}`}
            onAdd={() =>
                addArrayItem(
                    field
                )
            }
        >

            {(item[field] || []).map(
                (
                    value,
                    index
                ) => (

                    <div
                        key={index}
                        className="flex gap-3 mb-4"
                    >

                        <input
                            value={
                                value
                            }
                            onChange={(
                                e
                            ) =>
                                updateArray(
                                    field,
                                    index,
                                    e.target
                                        .value
                                )
                            }
                            className="flex-1 p-3 rounded-xl bg-black/40 border border-white/20"
                        />

                        <button
                            onClick={() =>
                                removeArrayItem(
                                    field,
                                    index
                                )
                            }
                            className="bg-red-600 px-4 rounded-xl"
                        >
                            Delete
                        </button>

                    </div>

                )
            )}

        </SectionCard>

    );
}